import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';

export default function GuestBookingLookup({ db, functions, navigateTo, initialBookingNumber = '', initialEmail = '' }) {
    const [bookingNumber, setBookingNumber] = useState(initialBookingNumber || '');
    const [email, setEmail] = useState(initialEmail || '');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialBookingNumber) setBookingNumber(initialBookingNumber);
        if (initialEmail) setEmail(initialEmail);
    }, [initialBookingNumber, initialEmail]);

    const handleLookup = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!bookingNumber || !email) {
            setError('Please enter both your booking number and email address.');
            setLoading(false);
            return;
        }

        try {
            const lookupGuestBooking = httpsCallable(functions, 'lookupGuestBooking');
            const result = await lookupGuestBooking({ bookingNumber: bookingNumber.trim(), email: email.trim() });
            
            const bookingData = result.data;
            if (bookingData) {
                 const bookingWithId = bookingData.id ? bookingData : { ...bookingData, id: bookingData.bookingNumber || 'view-guest-booking' };
                 navigateTo('bookingDetail', { booking: bookingWithId });
            } else {
                setError('An unexpected error occurred. No booking data was returned.');
            }
        } catch (err) {
            console.error("Error looking up booking:", err);
            setError(err.message || 'An unexpected error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto max-w-md py-12">
            <div className="bg-white p-8 rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-center mb-6">Find Your Booking</h1>
                <p className="text-center text-gray-600 mb-6">Enter your booking number (from your confirmation) and the email address you used to book.</p>
                <form onSubmit={handleLookup} className="space-y-4">
                    <input
                        type="text"
                        placeholder="Booking Number (e.g., BK-1234ABCD)"
                        value={bookingNumber}
                        onChange={(e) => setBookingNumber(e.target.value)}
                        className="w-full p-3 border rounded-lg"
                        required
                    />
                    <input
                        type="email"
                        placeholder="Your Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full p-3 border rounded-lg"
                        required
                    />
                    <button type="submit" disabled={loading} className="w-full bg-pink-500 text-white py-3 rounded-lg font-semibold hover:bg-pink-600 transition disabled:bg-gray-400">
                        {loading ? 'Searching...' : 'Find Booking'}
                    </button>
                    {error && <p className="text-red-500 text-sm text-center mt-4">{error}</p>}
                </form>
            </div>
        </div>
    );
}
